/*
  /certifications stores only { date, title }, so the issuer and its logo are
  resolved from the title. Nothing is written back and no field is added to the
  database. Logos live in public/assets/certs.

  `light` marks a logo whose artwork is drawn for a light background, so the
  tile renders it on white instead of on the dark surface.
*/

const ISSUERS = [
  { match: ["offsec", "oscp"], name: "OffSec", logo: "offsec.png" },
  { match: ["hackthebox", "htb"], name: "Hack The Box", logo: "hackthebox.png" },
  { match: ["tryhackme"], name: "TryHackMe", logo: "tryhackme.png" },
  { match: ["comptia"], name: "CompTIA", logo: "comptia.png", light: true },
  { match: ["cyberwarfare", "crta"], name: "CyberWarfare Labs", logo: "cyberwarfare.png" },
  {
    match: ["cnsp", "cap", "cmpen", "network security practitioner", "appsec practitioner", "mobile pentester"],
    name: "The SecOps Group",
    logo: "secops.png",
  },
];

export const issuerOf = (title = "") => {
  const name = title.toLowerCase();
  const found = ISSUERS.find(issuer => issuer.match.some(key => name.includes(key)));

  if (!found) return { name: "", logo: "", light: false };

  return { name: found.name, logo: `/assets/certs/${found.logo}`, light: !!found.light };
};

/* first letters of the title, used when no logo is known */
export const monogramOf = (title = "") =>
  title
    .replace(/[^a-zA-Z ]/g, " ")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map(word => word[0].toUpperCase())
    .join("");

/* the 4 digit year inside a date string such as "2nd May 2026" */
export const yearOf = (date = "") => {
  const found = date.match(/(19|20)\d{2}/);

  return found ? found[0] : "";
};

export default issuerOf;
